import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";

const SafariOnlySelector = (styles: SerializedStyles) => css`
  // Safari 10.1+ Selector
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      ${styles};
    }
  }

  // Safari 6.1-10.0 selector
  @media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
    @supports (-webkit-appearance: none) {
      ${styles};
    }
  }
`;

export { SafariOnlySelector };
